// Angular
import { Injectable } from "@angular/core";

// RXJS
import { BehaviorSubject } from "rxjs";

export interface SeoTitleState {
    getTitle: ((locale: string) => string | null) | null;
    prefix: string | null;
}

@Injectable({ providedIn: "root" })
export class SeoTitleStore {
    private readonly _state = new BehaviorSubject<SeoTitleState>({ getTitle: null, prefix: null });
    readonly state$ = this._state.asObservable();

    set(state: SeoTitleState): void {
        this._state.next(state);
    }

    reset(): void {
        this._state.next({ getTitle: null, prefix: null });
    }
}
